import { useCallback } from 'react'

import { fetch as fetchProviderLogistic } from '@/services/provider-logistic/fetch'

const PAGE_SIZE = 10

export const useProviderLogistic = () => {
  const loadOptions = useCallback(
    async (
      inputValue: string,
      _loadedOptions: unknown,
      additional?: { page: number }
    ) => {
      const page = additional?.page ?? 1

      if (inputValue && inputValue.length < 2) {
        return { options: [], hasMore: false, additional: { page: 1 } }
      }

      try {
        const data = await fetchProviderLogistic(inputValue, page, PAGE_SIZE)

        const hasMore =
          data.items.length === PAGE_SIZE && data.total > page * PAGE_SIZE
        return { options: data.items, hasMore, additional: { page: page + 1 } }
      } catch (error) {
        console.error('Error loading provider logistic:', error)
        return { options: [], hasMore: false, additional: { page: 1 } }
      }
    },
    []
  )

  return { loadOptions }
}
